import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/WebsitesInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/websites`;
	}
	detectSitemaps(e) {
		return this.api.post(`${n.baseUrl}/sitemapdetection`, e);
	}
};
//#endregion
export { n as WebsitesInternalResource };

//# sourceMappingURL=WebsitesInternalResource.js.map